module.exports = __webpack_public_path__ + "media/andenes/carretilla_automatica-f7b7d91d.webp";